<!-- 需求详情 -->
<template>
	<div class="wrap">

		<div class="header">
			<img src="../assets/return.png" class="return-img" @click="$router.back()">
			<p class="header-title">需求详情</p>
		</div>

		<div class="top-box">
			<div class="top-msg-box">
				<img src="../assets/img.png" class="top-msg-avatar">
				<div class="top-msg-sidebar">
					<p class="top-msg-name">我本人</p>
					<p class="top-msg-time">2022-06-12 12:20</p>
				</div>
				<span class="item-tag">待解决</span>
				<span class="item-tag blue">已解决</span>
			</div>
			<p class="top-price">
				¥<span>2344</span>
			</p>
			<p class="top-msg">
				需求描述需求描述需求描述需求描述需求描述需求描述需求描述需求描述需求描述需求描述需求描述需求描述需求描述需求描述需求描述需求描述需求描述需求描述需求描述需求描述需求描述需求描述需求描述需求描述需求描述需求描述需求描述需求描述需求描述需求描述需求描述需求描述需求描述
			</p>
			<img src="../assets/img.png" class="top-msg-img">
		</div>

		<div class="comment-wrap">
			<p class="all-comment-label">评论</p>
			<div class="all-comments-bottom">
				<img src="../assets/img.png" class="all-comments-avatar">
				<input type="" class="comment-input" placeholder="看对眼就留言，问问更多细节" name="" id="" value="" />
			</div>
			<ul class="comment-list">
				<li>
					<img src="../assets/img.png" class="avatar">
					<div class="comment-sidebar">
						<div class="comment-top-between">
							<span class="user-name">一号大怂包</span>
							<div class="comment-top-row">
								<button type="button">
									<img v-if="is_like === 1" src="../assets/hand2-active.png"
										style="margin-right: 4px;">
									<img v-else src="../assets/hand2.png" style="margin-right: 4px;">
									<span class="blue" v-if="is_like == 1">3632</span>
									<span class="gray" v-else>3632</span>
								</button>
								<button type="button">
									<img src="../assets/icon-39.png">
								</button>
							</div>
						</div>
						<div class="artice-wrap">
							<span>这个老师讲得真棒、内容也很好、可见老师功力深厚，这个老师讲得真棒、内容也很好、可见老师功力深厚</span>
							<!-- <span>{{ item.contentShort }}</span> -->
							<span class="all-blue-font">
								...全文
							</span>
							<span class="all-blue-font">
								收起
							</span>
						</div>
						<div class="time-wrap">
							<span class="time-font">2022-06-23 18:23</span>
							<button type="button" class="reply-btn">回复</button>
						</div>
						<div class="comment-box">
							<div class="comment-row">
								<span class="people">汽车之家</span>
								<span class="content">
									：<span>内容很喜欢，讲的确实好</span>
									<!-- <span >{{ item.parent.contentShort }}</span> -->

									<!-- <span class="all-blue-font">
										查看全文
									</span>
									<span class="all-blue-font">
										收起
									</span>
									<span class="all-blue-font">回复</span>
									<span class="all-blue-font">跳转</span> -->
								</span>
							</div>
						</div>
					</div>
				</li>
				<div class="check-all-comment">
					查看全部评论
					<img src="../assets/back-icon.png">
				</div>
				<!-- 无数据时显示 -->
				<div class="normal-comment-box">
					暂无评论
				</div>
			</ul>
		</div>

		<div class="footer">
			<button type="button" class="footer-btn">我能解决，联系官方</button>
		</div>

	</div>
</template>

<script>
	export default {
		components: {},
		data() {
			return {
				is_like: 1,
			};
		},
		mounted() {

		},
		methods: {

		}
	}
</script>

<style scoped>
	.wrap {
		width: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		padding: 44px 0 116px;
		box-sizing: border-box;
	}

	/* 头部样式 */
	.header {
		width: 100%;
		height: 44px;
		display: flex;
		justify-content: center;
		align-items: center;
		position: fixed;
		top: 0;
		left: 0;
		background-color: #FFFFFF;
		z-index: 999;
	}

	.return-img {
		position: absolute;
		left: 15px;
		top: 50%;
		transform: translate(0, -50%);
		width: 20px;
	}

	.header-title {
		color: #333333;
		font-size: 18px;
		font-weight: 500;
	}

	.footer {
		width: 100%;
		height: 116px;
		position: fixed;
		bottom: 0;
		left: 0;
		z-index: 999;
		display: flex;
		justify-content: center;
		align-items: center;
		padding: 0 35px;
		box-sizing: border-box;
	}

	.footer-btn {
		flex: 1;
		height: 44px;
		line-height: 44px;
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: 18px;
		font-weight: bold;
		color: #FFFFFF;
		background-color: #2A63F3;
		border-radius: 50px;
		box-sizing: border-box;
	}

	.top-box {
		width: 100%;
		display: flex;
		flex-direction: column;
		padding: 14px 15px 22px;
		border-bottom: 10px solid #F4F4F4;
		background-color: #FFFFFF;
		box-sizing: border-box;
	}

	.top-msg-box {
		width: 100%;
		display: flex;
		align-items: center;
		position: relative;
		margin-bottom: 16px;
	}

	.top-msg-avatar {
		width: 40px;
		height: 40px;
		border-radius: 50%;
		margin-right: 8px;
	}

	.top-msg-sidebar {
		flex: 1;
		display: flex;
		flex-direction: column;
	}

	.top-msg-name {
		width: 100%;
		color: #222222;
		font-size: 13px;
		font-weight: bold;
	}

	.top-msg-time {
		width: 100%;
		color: #999999;
		font-size: 11px;
	}

	.item-tag {
		width: fit-content;
		position: absolute;
		right: -15px;
		top: 0;
		color: #FFFFFF;
		font-size: 12px;
		height: 20px;
		line-height: 20px;
		display: flex;
		align-items: center;
		padding: 0 10px;
		background-color: #FF9833;
		border-radius: 30px 0 0 30px;
	}

	.item-tag.blue {
		background-color: #2A63F3;
		color: #FFFFFF !important;
	}

	.top-price {
		width: 100%;
		color: #FF4954;
		font-size: 14px;
		font-weight: bold;
		margin-bottom: 8px;
	}

	.top-price>span {
		font-size: 22px;
	}

	.top-msg {
		width: 100%;
		color: #666666;
		font-size: 13px;
		margin-bottom: 12px;
	}

	.top-msg-img {
		width: 100%;
	}

	.comment-wrap {
		width: 100%;
		display: flex;
		flex-direction: column;
		padding: 15px;
		box-sizing: border-box;
	}

	.all-comment-label {
		width: 100%;
		color: #222222;
		font-size: 16px;
		font-weight: bold;
		margin-bottom: 6px;
	}

	.comment-list {
		width: 100%;
		display: flex;
		flex-direction: column;
	}

	.comment-list>li {
		width: 100%;
		margin-bottom: 15px;
		display: flex;
		align-items: flex-start;
	}

	.avatar {
		width: 33px;
		height: 33px;
		border-radius: 50%;
		margin-right: 11px;
		margin-top: 2px;
	}

	.comment-sidebar {
		flex: 1;
		display: flex;
		flex-direction: column;
	}

	.comment-top-between {
		width: 100%;
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 4px;
	}

	.user-name {
		flex: 1;
		color: #222222;
		font-size: 13px;
		font-weight: bold;
	}

	.comment-top-row {
		display: flex;
		align-items: center;
	}

	.comment-top-row>button {
		display: flex;
		align-items: center;
		color: #555555;
		font-size: 12px;
		margin-right: 12px;
	}

	.comment-top-row>button:last-child {
		margin-right: 0;
	}

	.comment-top-row>button>img {
		width: 14px;
	}

	.artice-wrap {
		width: 100%;
		color: #222222;
		font-size: 14px;
		margin-bottom: 6px;
	}

	.all-blue-font {
		color: #2A63F3;
		font-size: 14px;
		margin: 0 5px;
	}

	.time-wrap {
		width: 100%;
		display: flex;
		align-items: center;
		margin-bottom: 8px;
	}

	.time-font {
		color: #666666;
		font-size: 12px;
	}

	.reply-btn {
		margin-left: 3px;
		padding: 0 8px;
		color: #555555;
		font-size: 12px;
		font-weight: bold;
	}

	.comment-box {
		width: 100%;
		display: flex;
		flex-direction: column;
	}

	.comment-row {
		width: 100%;
		margin-bottom: 5px;
		border-left: 1px solid #F3F3F3;
		padding-left: 4px;
		box-sizing: border-box;
	}

	.comment-row:last-child {
		margin-bottom: 0;
	}

	.people {
		color: #2A63F3;
		font-size: 13px;
	}

	.content {
		color: #222222;
		font-size: 13px;
	}

	.normal-comment-box {
		display: flex;
		flex-direction: column;
		align-items: center;
		width: 100%;
		padding: 66px 0;
		font-size: 14px;
		color: #7F7F7F;
	}

	.blue {
		color: #2A63F3;
		font-size: 10px;
	}

	.gray {
		font-size: 10px;
		color: #333333;
	}

	.check-all-comment {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		color: #888888;
		font-size: 12px;
	}

	.check-all-comment>img {
		width: 4px;
		margin-left: 4px;
	}

	.all-comments-bottom {
		width: 100%;
		margin-bottom: 15px;
		display: flex;
		align-items: center;
		background-color: #FFFFFF;
	}

	.comment-input {
		flex: 1;
		height: 32px;
		line-height: 32px;
		background-color: #F3F3F3;
		border-radius: 50px;
		padding: 0 12px;
		box-sizing: border-box;
		font-size: 13px;
	}

	.comment-input::placeholder {
		color: #999999;
	}

	.all-comments-avatar {
		width: 34px;
		height: 34px;
		border-radius: 50%;
		margin-right: 10px;
	}
</style>
